/**
 * Mozaik events on the shared arcade telemetry (@kit/telemetry: PostHog EU + Sentry, tagged
 * `game: "mozaik"`). Every event also carries the running experiments' variants so metrics split
 * cleanly (CLAUDE.md §4). Event schema: docs/events.md.
 */
import { track as kitTrack } from "@kit/telemetry";
import { HD_PICTURES_SPEC, experimentProps, hdPicturesVariant } from "./experiments";

export type EventName =
  | "app_open"
  | "level_start"
  | "level_end"
  | "move"
  | "special_created"
  | "moment" // big combo / clutch win / one-move-loss, for the video factory
  | "share_click"
  | "share_done"
  | "skip_used"
  | "retry"
  | "map_open" // level map: unlocked, stars, from
  | "map_play" // level, replay
  | "experiment_exposure"; // experiment, variant, mode ("classic") — once per session

export function track(name: EventName, eventProps: Record<string, string | number | boolean> = {}): void {
  kitTrack(name, { ...experimentProps(), ...eventProps });
}

const exposed = new Set<string>();

/** First time this session a mode shows an experiment-affected picture: one exposure per mode. */
export function trackExposure(mode: string): void {
  if (exposed.has(mode)) return;
  exposed.add(mode);
  track("experiment_exposure", { experiment: HD_PICTURES_SPEC.key, variant: hdPicturesVariant(), mode });
}
